<template>
  <div class="flex upload-head-img">
    <el-upload
      class="upload"
      :limit="5"
      action="#"
      :headers="{access_token: $store.getters.AppInfo.accessToken}"
      list-type="picture-card"
      :show-file-list="false"
      :before-upload="uploadImg"
    >
      <img v-if="fileList" :src="fileList" alt />
      <img v-else :src="headImgUrl" alt />
      <el-link  type="primary" class="text-upload" v-if="show">上传会员头像 <i class="el-icon-arrow-right iconRight"></i></el-link>
      <el-link  type="primary" class="text-upload" v-else>上传店员头像 <i class="el-icon-arrow-right iconRight"></i></el-link>
    </el-upload>
  </div>
</template>

<script lang="ts">
import OSS from "ali-oss";
import { compressImage } from "../../../assets/javascript/untils";
export default {
  props: ["fileList", "module", 'show'],
  data() {
    return {
      headImgUrl: require("../../../assets/images/new/avater.png"),
      myFileList: this.fileList,
      myHeaders: {},
      oss: null,
      ids: [],
      ossParmar: {}
    };
  },
  created() {
    
  },
  watch: {
    fileList() {
      this.myFileList = this.fileList;
    }
  },
  methods: {
    async getSts () {
      let res = await this.$api.get(this.$url.merchatOss.getSts, {module: this.module })
      if (res) {
        this.oss = new OSS({
          region: process.env.VUE_APP_CURRENTMODE == 'production' ? 'oss-cn-shanghai' : 'oss-cn-beijing',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucketName,
          stsToken: res.securityToken,
          securityToken: res.securityToken
        })
        this.ossParmar = res;
      }
    },
    async confirmImg (file) {
      let ret = await this.$api.post(this.$url.merchatOss.listUploadId, {size: 1, module: this.module, securityType: this.ossParmar.securityType, bucketName: this.ossParmar.bucketName})
      if (ret) {
        this.ids = ret;
      }
      try {
        const imgPath = this.module + "/" + this.ids[0] + '.png';
        const result = await this.oss.put(imgPath, file);
        let arr = result.url.split('/');
        let url = this.ossParmar.imgDomain + '/' + arr[3] + '/' + arr[4];
        this.$emit("file", url);
      } catch (e) {
        this.$message.warning('页面过期，请重新刷新页面');
        this.getSts();
      }
    },
    async uploadImg(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG) {
        this.$message.error("上传头像图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        return false;
      }

      console.log("压缩前文件", file);
      file = await compressImage(file);
      console.log("压缩后文件", file);

      let res = await this.$api.get(this.$url.merchatOss.getSts, {module: this.module })
      if (res) {
        this.oss = new OSS({
          region: process.env.VUE_APP_CURRENTMODE == 'production' ? 'oss-cn-shanghai' : 'oss-cn-beijing',
          accessKeyId: res.accessKeyId,
          accessKeySecret: res.accessKeySecret,
          bucket: res.bucketName,
          stsToken: res.securityToken,
          securityToken: res.securityToken
        })
        this.ossParmar = res;

        this.confirmImg(file);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.iconRight {
  font-size: 16px;
  vertical-align: middle;
  color: #409eff;
}

.upload {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
}
/deep/ div .el-upload--picture-card {
  background-color: #fff;
  border: 0;
  border-radius: 50%;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 60px;
  line-height: 60px;
  vertical-align: top;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .icons {
    font-size: 45px;
    color: @blue;
    font-weight: bold;
  }
  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-sizing: border-box;
  }
}
.el-upload--picture-card {
  display: flex;
  justify-content: center;
  [class^="el-icon-"] {
    line-height: inherit;
  }
}
.flex {
  width: 100%;
  display: flex;
  flex-direction: row;
}
ul li {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 166px;
  height: 110px;
  margin: 0 8px 0 0;
  position: relative;
  display: inline-block;
}
.el-image {
  width: 166px;
  height: 110px;
}
.delete {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  &:hover {
    opacity: 1;
    cursor: pointer;
  }
  i {
    text-align: center;
    line-height: 110px;
  }
}
</style>